import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { Slider } from 'primereact/slider';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { ToggleButton } from 'primereact/togglebutton';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { FileUpload } from 'primereact/fileupload';

import { useAuth } from "./AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";
import { Toast } from 'primereact/toast';
import { Rating } from 'primereact/rating';
import CustomerService from '../service/CustomerService';
import ProductService from '../service/ProductService';
import axios from "axios";



const TableBarrios = () => {

    const { administracionId } = useAuth();
    const t = useTerminologia();

    const toast = useRef();

    const HOST_API = process.env.REACT_APP_URL;
    const url = `${HOST_API}api/barrios/GetBarriosConResumen?administracionId=${administracionId}`;

    const [barrios, setBarrios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tiposLiquidacion, setTiposLiquidacion] = useState([]);

    const fetchBarrios = async () => {
        try {
            const response = await axios.get(url);
            setBarrios(response.data); // suponiendo que tu API devuelve un array de barrios
        } catch (err) {
            setError(err.message || "Error al obtener barrios");
        } finally {
            setLoading(false);
        }
    };

    const fetchTiposLiquidacion = async () => {
        try {
            const { data } = await axios.get(`${HOST_API}api/tiposLiquidacion/GetTiposLiquidacion`);
            setTiposLiquidacion(data || []);
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron obtener los tipos de liquidación', life: 3000 });
        }
    };

    useEffect(() => {
        fetchBarrios();
        fetchTiposLiquidacion();
    }, []);

    const initialEditFormData = {
        barrioId: 0,
        tipoLiquidacionId: 0,
        nombreBarrio: '',
        direccion: '',
        cuit: '',
        email: '',
        activo: true,
        administracionId: administracionId,
        razonSocial: '',
        numeroCuenta: '',
        cuentaBancaria: '',
        tipoCuentaBancaria: '',
        alias: '',
        imagenUrl: ''
    };

    const [editVisible, setEditVisible] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [editSaving, setEditSaving] = useState(false);
    const [editFormData, setEditFormData] = useState(initialEditFormData);
    const [imagenArchivo, setImagenArchivo] = useState(null);

    const handleNewClick = () => {
        setEditFormData({ ...initialEditFormData, administracionId });
        setImagenArchivo(null);
        setEditVisible(true);
    };

    const handleEditClick = async (rowData) => {
        setEditLoading(true);
        try {
            const { data } = await axios.get(`${HOST_API}api/barrios/getBarrios?barrioId=${rowData.barrioId}&administracionId=${administracionId}`);
            const barrio = Array.isArray(data) ? data[0] : data;
            if (!barrio) {
                throw new Error(`${t.Barrio} no encontrado`);
            }
            setEditFormData({
                barrioId: barrio.barrioId,
                tipoLiquidacionId: barrio.tipoLiquidacionId,
                nombreBarrio: barrio.nombreBarrio || '',
                direccion: barrio.direccion || '',
                cuit: barrio.cuit || '',
                email: barrio.email || '',
                activo: barrio.activo,
                administracionId: barrio.administracionId,
                razonSocial: barrio.razonSocial || '',
                numeroCuenta: barrio.numeroCuenta || '',
                cuentaBancaria: barrio.cuentaBancaria || '',
                tipoCuentaBancaria: barrio.tipoCuentaBancaria || '',
                alias: barrio.alias || '',
                imagenUrl: rowData.imagenUrl || ''
            });
            setImagenArchivo(null);
            setEditVisible(true);
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `No se pudo obtener el ${t.Barrio.toLowerCase()}`, life: 3000 });
        } finally {
            setEditLoading(false);
        }
    };

    const handleSaveEdit = async (e) => {
        e.preventDefault();
        const esNuevo = !editFormData.barrioId;
        setEditSaving(true);
        try {
            const { data: barrioId } = await axios.post(`${HOST_API}api/barrios/SaveBarrio`, editFormData);

            if (imagenArchivo && barrioId) {
                const fd = new FormData();
                fd.append('file', imagenArchivo);
                await axios.post(
                    `${HOST_API}api/barrios/SubirImagenBarrio?barrioId=${barrioId}&administracionId=${administracionId}`,
                    fd
                );
            }

            setEditVisible(false);
            setImagenArchivo(null);
            showSuccess(t.Barrios, `${t.Barrio} ${editFormData.nombreBarrio} ${esNuevo ? 'creado' : 'actualizado'} correctamente.`);
            await fetchBarrios();
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `No se pudo guardar el ${t.Barrio.toLowerCase()}`, life: 3000 });
        } finally {
            setEditSaving(false);
        }
    };

    const editBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-pencil"
                rounded
                text
                severity="warning"
                loading={editLoading}
                onClick={() => handleEditClick(rowData)}
                tooltip="Editar"
            />
        );
    };

    const [customers1, setCustomers1] = useState(null);
    const [customers2, setCustomers2] = useState([]);
    const [customers3, setCustomers3] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [idFrozen, setIdFrozen] = useState(false);
    const [products, setProducts] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);


    const representatives = [
        { name: 'Amy Elsner', image: 'amyelsner.png' },
        { name: 'Anna Fali', image: 'annafali.png' },
        { name: 'Asiya Javayant', image: 'asiyajavayant.png' },
        { name: 'Bernardo Dominic', image: 'bernardodominic.png' },
        { name: 'Elwin Sharvill', image: 'elwinsharvill.png' },
        { name: 'Ioni Bowcher', image: 'ionibowcher.png' },
        { name: 'Ivan Magalhaes', image: 'ivanmagalhaes.png' },
        { name: 'Onyama Limba', image: 'onyamalimba.png' },
        { name: 'Stephen Shaw', image: 'stephenshaw.png' },
        { name: 'XuXue Feng', image: 'xuxuefeng.png' }
    ];

    const statuses = ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'];

    const customerService = new CustomerService();
    const productService = new ProductService();

    useEffect(() => {
        setLoading2(true);

        customerService.getCustomersLarge().then((data) => {
            setCustomers1(getCustomers(data));
            setLoading1(false);
        });
        customerService.getCustomersLarge().then((data) => {
            setCustomers2(getCustomers(data));
            setLoading2(false);
        });
        customerService.getCustomersMedium().then((data) => setCustomers3(data));
        productService.getProductsWithOrdersSmall().then((data) => setProducts(data));

        initFilters1();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const showSuccess = (titulo, mensaje) => {
        toast.current.show({ severity: 'success', summary: titulo, detail: mensaje, life: 3000 });
    };

    const balanceTemplate = (rowData) => {
        return <span className="text-bold">{ (Math.random() * 10000).toFixed(0) }</span>;
    };

    const getCustomers = (data) => {
        return [...(data || [])].map((d) => {
            d.date = new Date(d.date);
            return d;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const initFilters1 = () => {
        setFilters1({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'country.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            representative: { value: null, matchMode: FilterMatchMode.IN },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            balance: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
            verified: { value: null, matchMode: FilterMatchMode.EQUALS }
        });
    };

    const countryBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <img alt="flag" src="assets/demo/flags/flag_placeholder.png" className={`flag flag-${rowData.country.code}`} width={30} />
                <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">
                    {rowData.country.name}
                </span>
            </React.Fragment>
        );
    };

    const filterClearTemplate = (options) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} className="p-button-secondary"></Button>;
    };

    const filterApplyTemplate = (options) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} className="p-button-success"></Button>;
    };

    const representativeBodyTemplate = (rowData) => {
        const representative = rowData.representative;
        return (
            <React.Fragment>
                <img
                    alt={representative.name}
                    src={`assets/demo/images/avatar/${representative.image}`}
                    onError={(e) => (e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png')}
                    width={32}
                    style={{ verticalAlign: 'middle' }}
                />
                <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">
                    {representative.name}
                </span>
            </React.Fragment>
        );
    };

    const representativeFilterTemplate = (options) => {
        return (
            <>
                <div className="mb-3 text-bold">Agent Picker</div>
                <MultiSelect value={options.value} options={representatives} itemTemplate={representativesItemTemplate} onChange={(e) => options.filterCallback(e.value)} optionLabel="name" placeholder="Any" className="p-column-filter" />
            </>
        );
    };

    const representativesItemTemplate = (option) => {
        return (
            <div className="p-multiselect-representative-option">
                <img alt={option.name} src={`assets/demo/images/avatar/${option.image}`} width={32} style={{ verticalAlign: 'middle' }} />
                <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">
                    {option.name}
                </span>
            </div>
        );
    };

    const dateBodyTemplate = (rowData) => {
        return formatDate(rowData.date);
    };

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };

    const balanceBodyTemplate = (rowData) => {
        return formatCurrency(rowData.balance);
    };

    const balanceFilterTemplate = (options) => {
        return <InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="USD" locale="en-US" />;
    };

    const statusBodyTemplate = (rowData) => {
        return <span className={`customer-badge status-${rowData.status}`}>{rowData.status}</span>;
    };

    const statusBarrio = (rowData) => {
        const s = rowData.activo
            ? { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5', label: 'Activo' }
            : { bg: '#fef3f2', color: '#f04438', border: '#fecdca', label: 'No Activo' };
        return (
            <span style={{
                background: s.bg, color: s.color, border: `1px solid ${s.border}`,
                fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
            }}>
                {s.label}
            </span>
        );
    };

    // const statusBodyTemplate2 = (rowData) => {
    //     return <span className={`customer-badge status-${rowData.borrado}`}>{rowData.borrado}</span>;
    // };

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Select a Status" className="p-column-filter" showClear />;
    };

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option}`}>{option}</span>;
    };

    const activityBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.activity} showValue={false} style={{ height: '.5rem' }}></ProgressBar>;
    };

    const activityFilterTemplate = (options) => {
        return (
            <React.Fragment>
                <Slider value={options.value} onChange={(e) => options.filterCallback(e.value)} range className="m-3"></Slider>
                <div className="flex align-items-center justify-content-between px-2">
                    <span>{options.value ? options.value[0] : 0}</span>
                    <span>{options.value ? options.value[1] : 100}</span>
                </div>
            </React.Fragment>
        );
    };

    const verifiedBodyTemplate = (rowData) => {
        return <i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.verified, 'text-pink-500 pi-times-circle': !rowData.verified })}></i>;
    };

    const verifiedFilterTemplate = (options) => {
        return <TriStateCheckbox value={options.value} onChange={(e) => options.filterCallback(e.value)} />;
    };

    const expandAll = () => {
        let _expandedRows = {};
        products.forEach((p) => (_expandedRows[`${p.id}`] = true));

        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const amountBodyTemplate = (rowData) => {
        return formatCurrency(rowData.amount);
    };

    const statusOrderBodyTemplate = (rowData) => {
        return <span className={`order-badge order-${rowData.status.toLowerCase()}`}>{rowData.status}</span>;
    };

    const searchBodyTemplate = () => {
        return <Button icon="pi pi-search" />;
    };
    /*
    const openBarrio = (rowData) => {
        const { seleccionarBarrio } = useContext(BarrioContext);
        return <Button label="Seleccionar" className="p-button-outlined p-button-info mr-2 mb-2" onClick={() => seleccionarBarrio(rowData.barrioId, rowData.nombreBarrio, rowData.cuit, rowData.direccion, rowData.razonSocial, rowData.numeroCuenta, rowData.cuentaBancaria, rowData.tipoCuentaBancaria, rowData.alias)} />
    };
    const seleccionarBarrio = (barrio) => {
        localStorage.setItem("barrioId", barrio.barrioId);
        localStorage.setItem("nombreBarrio", barrio.nombreBarrio);

        console.log("barrioId", barrio.barrioId);
        console.log("nombreBarrio", barrio.nombreBarrio);

        // si usás un estado global/context podés actualizarlo acá
        // o disparar un evento para que la Nav lo lea
        console.log("Barrio seleccionado:", barrio.nombreBarrio);
    };
    */
    const imageBodyTemplate = (rowData) => {
        return <img src={`assets/demo/images/product/${rowData.image}`} onError={(e) => (e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png')} alt={rowData.image} className="shadow-2" width={100} />;
    };

    const priceBodyTemplate = (rowData) => {
        return formatCurrency(rowData.price);
    };

    const ratingBodyTemplate = (rowData) => {
        return <Rating value={rowData.rating} readOnly cancel={false} />;
    };

    const statusBodyTemplate2 = (rowData) => {
        return <span className={`product-badge status-${rowData.inventoryStatus.toLowerCase()}`}>{rowData.inventoryStatus}</span>;
    };

    const rowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">
                <h5>Orders for {data.name}</h5>
                <DataTable value={data.orders} responsiveLayout="scroll">
                    <Column field="id" header="Id" sortable></Column>
                    <Column field="customer" header="Customer" sortable></Column>
                    <Column field="date" header="Date" sortable></Column>
                    <Column field="amount" header="Amount" body={amountBodyTemplate} sortable></Column>
                    <Column field="status" header="Status" body={statusOrderBodyTemplate} sortable></Column>
                    <Column headerStyle={{ width: '4rem' }} body={searchBodyTemplate}></Column>
                </DataTable>
            </div>
        );
    };

    const header = (
        <div className="table-header-container">
            <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} className="mr-2 mb-2" />
            <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} className="mb-2" />
        </div>
    );

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <img alt={data.representative.name} src={`assets/demo/images/avatar/${data.representative.image}`} width="32" style={{ verticalAlign: 'middle' }} />
                <span className="image-text font-bold ml-2">{data.representative.name}</span>
            </React.Fragment>
        );
    };

    const footerTemplate = (data) => {
        return (
            <React.Fragment>
                <td colSpan="4" style={{ textAlign: 'right' }} className="text-bold pr-6">
                    Total Customers
                </td>
                <td>{calculateCustomerTotal(data.representative.name)}</td>
            </React.Fragment>
        );
    };

    const calculateCustomerTotal = (name) => {
        let total = 0;

        if (customers3) {
            for (let customer of customers3) {
                if (customer.representative.name === name) {
                    total++;
                }
            }
        }

        return total;
    };

    // const renderHeaderBarrio = () => {
    //     return (
    //         <div className="flex justify-content-between">
    //             <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
    //             <IconField iconPosition="left">
    //                 <InputIcon className="pi pi-search" />
    //                 <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
    //             </IconField>
    //         </div>
    //     );
    // };

    //     const clearFilter = () => {
    //     initFilters();
    // };

    // const onGlobalFilterChange = (e) => {
    //     const value = e.target.value;
    //     let _filters = { ...filters };

    //     _filters['global'].value = value;

    //     setFilters(_filters);
    //     setGlobalFilterValue(value);
    // };

    // const headerBarrio = renderHeaderBarrio();

    return (
        
        <>
            <h4>{t.Barrios}</h4>
            <br />

            <Toast ref={toast} />
            <Dialog
                header={editFormData.barrioId ? `Editar ${t.Barrio}` : `Nuevo ${t.Barrio}`}
                visible={editVisible}
                style={{ width: '520px' }}
                breakpoints={{ '960px': '100vw' }}
                modal
                onHide={() => setEditVisible(false)}
            >
                <form onSubmit={handleSaveEdit}>
                    <div className="flex flex-column gap-3 mt-2">
                        <div>
                            <label style={labelStyle}>Nombre <span style={{ color: '#f04438' }}>*</span></label>
                            <InputText value={editFormData.nombreBarrio} onChange={(e) => setEditFormData(p => ({ ...p, nombreBarrio: e.target.value }))} className="p-inputtext-sm w-full" required />
                        </div>
                        <div>
                            <label style={labelStyle}>Dirección</label>
                            <InputText value={editFormData.direccion} onChange={(e) => setEditFormData(p => ({ ...p, direccion: e.target.value }))} className="p-inputtext-sm w-full" />
                        </div>
                        <div>
                            <label style={labelStyle}>Tipo de Liquidación <span style={{ color: '#f04438' }}>*</span></label>
                            <Dropdown
                                value={editFormData.tipoLiquidacionId}
                                options={tiposLiquidacion}
                                optionLabel="descripcion"
                                optionValue="tipoLiquidacionId"
                                onChange={(e) => setEditFormData(p => ({ ...p, tipoLiquidacionId: e.value }))}
                                placeholder="Seleccione un tipo de liquidación"
                                className="p-inputtext-sm w-full"
                                required
                            />
                        </div>
                        <div className="flex gap-3">
                            <div className="flex-1">
                                <label style={labelStyle}>CUIT</label>
                                <InputText value={editFormData.cuit} onChange={(e) => setEditFormData(p => ({ ...p, cuit: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                            <div className="flex-1">
                                <label style={labelStyle}>Email</label>
                                <InputText value={editFormData.email} onChange={(e) => setEditFormData(p => ({ ...p, email: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                        </div>
                        <div>
                            <label style={labelStyle}>Razón Social</label>
                            <InputText value={editFormData.razonSocial} onChange={(e) => setEditFormData(p => ({ ...p, razonSocial: e.target.value }))} className="p-inputtext-sm w-full" />
                        </div>
                        <div className="flex gap-3">
                            <div className="flex-1">
                                <label style={labelStyle}>Número de Cuenta</label>
                                <InputText value={editFormData.numeroCuenta} onChange={(e) => setEditFormData(p => ({ ...p, numeroCuenta: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                            <div className="flex-1">
                                <label style={labelStyle}>Cuenta Bancaria</label>
                                <InputText value={editFormData.cuentaBancaria} onChange={(e) => setEditFormData(p => ({ ...p, cuentaBancaria: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex-1">
                                <label style={labelStyle}>Tipo de Cuenta Bancaria</label>
                                <InputText value={editFormData.tipoCuentaBancaria} onChange={(e) => setEditFormData(p => ({ ...p, tipoCuentaBancaria: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                            <div className="flex-1">
                                <label style={labelStyle}>Alias</label>
                                <InputText value={editFormData.alias} onChange={(e) => setEditFormData(p => ({ ...p, alias: e.target.value }))} className="p-inputtext-sm w-full" />
                            </div>
                        </div>
                        <div>
                            <label style={labelStyle}>Imagen</label>
                            {editFormData.imagenUrl && !imagenArchivo && (
                                <img
                                    src={`${HOST_API}${editFormData.imagenUrl}`.replace(/([^:])\/\/+/g, '$1/')}
                                    alt={editFormData.nombreBarrio}
                                    style={{ maxHeight: 120, borderRadius: 8, display: 'block', marginBottom: 8 }}
                                />
                            )}
                            <FileUpload
                                mode="basic"
                                name="imagen"
                                accept=".jpg,.jpeg,.png"
                                maxFileSize={5000000}
                                chooseLabel={editFormData.imagenUrl ? 'Cambiar imagen' : 'Adjuntar imagen'}
                                onSelect={(e) => setImagenArchivo(e.files[0])}
                                onClear={() => setImagenArchivo(null)}
                            />
                        </div>
                        <div className="flex align-items-center gap-2">
                            <InputSwitch checked={!!editFormData.activo} onChange={(e) => setEditFormData(p => ({ ...p, activo: e.value }))} />
                            <label style={labelStyle}>Activo</label>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-2">
                            <Button label="Cancelar" type="button" severity="secondary" text onClick={() => setEditVisible(false)} />
                            <Button label="Guardar" icon="pi pi-save" type="submit" loading={editSaving} />
                        </div>
                    </div>
                </form>
            </Dialog>
            {/* <div>

                <img src='/assets/layout/images/administradoras/zaputovich.png' style={{ marginLeft: "10px", width: "200px" }} ></img>

            </div> */}

            <div className="flex align-items-center gap-3 mb-3">
                <Button label={`Nuevo ${t.Barrio}`} icon="pi pi-plus" onClick={handleNewClick} />
            </div>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                    value={barrios}
                    paginator
                    className="p-datatable-gridlines bg-white"
                    showGridlines
                    rows={10}
                    dataKey="barrioId"
                    filterDisplay="menu"
                    loading={loading}
                    responsiveLayout="scroll"
                    emptyMessage={`No se encontraron ${t.barrios}.`}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    // globalFilterFields={['nombreBarrio', 'direccion', 'cuit', 'email']} header={header}
                    >
                    <Column
                        field="nombreBarrio"
                        header={`Nombre ${t.Barrio}`}
                        filter
                        sortable 
                        filterPlaceholder="Buscar por nombre"
                        style={{ minWidth: "12rem" }}
                    />
                    <Column
                        field="direccion"
                        header="Dirección"
                        filter
                        style={{ minWidth: "10rem" }}
                    />
                    <Column
                        field="cuit"
                        header="CUIT"
                        filter
                        style={{ minWidth: "10rem" }}
                    />
                    <Column
                        field="email"
                        header="Email"
                        filter
                        style={{ minWidth: "12rem" }}
                    />
                    <Column
                        field="borrado"
                        header="Estado"
                        filter
                        style={{ minWidth: "12rem" }}
                        body={statusBarrio}
                    />
                    <Column
                        header="Editar"
                        style={{ minWidth: "6rem", textAlign: "center" }}
                        body={editBodyTemplate}
                    />
                    </DataTable>
                    {/* <DataTable
                        value={barrios}
                        paginator
                        className="p-datatable-gridlines"
                        showGridlines
                        rows={10}
                        dataKey="barrioId"
                        //filters={filters1}
                        filterDisplay="menu"
                        loading={loading1}
                        responsiveLayout="scroll"
                        emptyMessage="No customers found."
                    >
                        <Column field="barrioId" header="Nro Barrio" filter filterPlaceholder="Search by name" style={{ minWidth: '12rem' }} />
                        <Column header="nombreBarrio" filterField="nombreBarrio" style={{ minWidth: '12rem' }} body={countryBodyTemplate} filter filterPlaceholder="Search by country" filterClear={filterClearTemplate} filterApply={filterApplyTemplate} />
                        <Column header="direccion" filterField="direccion" dataType="text" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                        <Column header="cuit" filterField="balance" dataType="cuit" style={{ minWidth: '10rem' }} body={balanceBodyTemplate} filter filterElement={balanceFilterTemplate} />
                        <Column field="email" header="email" filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} body={statusBodyTemplate} filter filterElement={statusFilterTemplate} />
                    </DataTable> */}
                </div>
            </div>

            {/* <div className="col-12">
                <div className="card">
                    <h5>Frozen Columns</h5>
                    <ToggleButton checked={idFrozen} onChange={(e) => setIdFrozen(e.value)} onIcon="pi pi-lock" offIcon="pi pi-lock-open" onLabel="Unfreeze Id" offLabel="Freeze Id" style={{ width: '10rem' }} />

                    <DataTable value={customers2} scrollable scrollHeight="400px" loading={loading2} scrollDirection="both" className="mt-3">
                        <Column field="name" header="Name" style={{ flexGrow: 1, flexBasis: '160px' }} frozen></Column>
                        <Column field="id" header="Id" style={{ flexGrow: 1, flexBasis: '100px' }} frozen={idFrozen} alignFrozen="left"></Column>
                        <Column field="name" header="Name" style={{ flexGrow: 1, flexBasis: '200px' }}></Column>
                        <Column field="country.name" header="Country" style={{ flexGrow: 1, flexBasis: '200px' }} body={countryBodyTemplate}></Column>
                        <Column field="date" header="Date" style={{ flexGrow: 1, flexBasis: '200px' }} body={dateBodyTemplate}></Column>
                        <Column field="company" header="Company" style={{ flexGrow: 1, flexBasis: '200px' }}></Column>
                        <Column field="status" header="Status" style={{ flexGrow: 1, flexBasis: '200px' }} body={statusBodyTemplate}></Column>
                        <Column field="activity" header="Activity" style={{ flexGrow: 1, flexBasis: '200px' }}></Column>
                        <Column field="representative.name" header="Representative" style={{ flexGrow: 1, flexBasis: '200px' }} body={representativeBodyTemplate}></Column>
                        </DataTable>
                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <h5>Row Expand</h5>
                    <DataTable value={products} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} responsiveLayout="scroll" rowExpansionTemplate={rowExpansionTemplate} dataKey="id" header={header}>
                        <Column expander style={{ width: '3em' }} />
                        <Column field="name" header="Name" sortable />
                        <Column header="Image" body={imageBodyTemplate} />
                        <Column field="price" header="Price" sortable body={priceBodyTemplate} />
                        <Column field="category" header="Category" sortable />
                        <Column field="rating" header="Reviews" sortable body={ratingBodyTemplate} />
                        <Column field="inventoryStatus" header="Status" sortable body={statusBodyTemplate2} />
                    </DataTable>
                </div>
            </div> */}

            {/* <div className="col-12">
                <div className="card">
                    <h5>Subheader Grouping</h5>
                    <DataTable
                        value={customers3}
                        rowGroupMode="subheader"
                        groupRowsBy="representative.name"
                        sortMode="single"
                        sortField="representative.name"
                        sortOrder={1}
                        scrollable
                        scrollHeight="400px"
                        rowGroupHeaderTemplate={headerTemplate}
                        rowGroupFooterTemplate={footerTemplate}
                        responsiveLayout="scroll"
                    >
                        <Column field="name" header="Name" style={{ minWidth: '200px' }}></Column>
                        <Column field="country" header="Country" body={countryBodyTemplate} style={{ minWidth: '200px' }}></Column>
                        <Column field="company" header="Company" style={{ minWidth: '200px' }}></Column>
                        <Column field="status" header="Status" body={statusBodyTemplate} style={{ minWidth: '200px' }}></Column>
                        <Column field="date" header="Date" style={{ minWidth: '200px' }}></Column>
                    </DataTable>
                </div>
            </div> */}
        </>
    );
};

const labelStyle = { display: 'block', marginBottom: '0.35rem', fontWeight: 500, color: '#344054', fontSize: '0.87rem' };

export default TableBarrios;
